import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild, } from "@angular/core";
import { Rcms } from "eddydata-lib";
import { ImprimirNotaRcmsRpt } from "./imprimir-nota-rcms-rpt/imprimir-nota-rcms-rpt.component";
import { PendenciaAssinaturaService } from "projects/eddydata-lib/src/lib/pendencia-assinatura/service/pendencia-assinatura.service";

@Component({
  selector: "lib-nota-rcms-rpt",
  templateUrl: "./nota-rcms-rpt.component.html",
})
export class NotaRcmsRpt implements AfterViewInit {

  @Input() rcms: Rcms[];
  @Input() visualizar: boolean = false;
  @Input() mostrarDescricao: boolean = false;
  @Input() download: boolean = false;
  @Input() url: boolean = false;
  @Input() unificarArquivos: boolean = false;
  @Output() href: EventEmitter<Blob> = new EventEmitter();

  @Output() visualizarChange: EventEmitter<boolean> = new EventEmitter();

  @ViewChild(ImprimirNotaRcmsRpt)
  imprimirNotaRcmsRptComponent: ImprimirNotaRcmsRpt;

  titulo: string;

  constructor(protected pendenciaAssinaturaService: PendenciaAssinaturaService,
    private cd: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.titulo = this.imprimirNotaRcmsRptComponent.tituloRelatorio();
    this.cd.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  public async show() {
    setTimeout(async () => {
      if (!this.url) {
        if (this.rcms?.length === 1) {
          const pendencia = await this.pendenciaAssinaturaService.obter({ 'id_entidade': this.rcms[0].id, 'etapa.etapa.nome': 'NOVA_REQUISICAO', 'aceito$null': true, 'orderBy': 'etapa.ordem$DESC' }).toPromise();
          if (pendencia && pendencia.id_storage) {
            this.imprimir();
          } else {
            this.visualizar = true;
            this.visualizarChange.emit(this.visualizar);
          }
        } else {
          this.visualizar = true;
          this.visualizarChange.emit(this.visualizar);
        }
      } else if (this.rcms?.length === 1 && this.rcms[0]['notaEmpenho']) {
        await this.imprimir();
      }
    }, 50);
  }

  public hide() {
    this.visualizar = false;
    this.visualizarChange.emit(this.visualizar);
  }

  imprimir() {
    this.imprimirNotaRcmsRptComponent.imprimir();
  }
}
